import { ButtonType, LargeButton } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import PortalTextBox from '../../portal/portalTextBox';

@inject('translationsStore', 'authStore', 'authenticationProvidersStore','adminConfigurationStore') @observer
export default class TenantLoginForm extends Component {

    componentDidMount() {
        var existingTenantVal = window.localStorage.getItem('authStoreTenant');
        if (existingTenantVal) {
            this.props.authStore.setTenant(existingTenantVal);
        }
        if (this.props.authStore.values.tenant) {
            this.props.adminConfigurationStore.getForgotPasswordSetting();
            const Auths = this.props.authenticationProvidersStore.getAllAuthenticationProvidersOfTenant().then(response => {
                this.props.authStore.setLoginStep(this.props.authStore.loginSteps.passwordForm);
                return response;
            });
        }
    }

    componentWillUnmount() {
        this.props.authStore.resetTenantForm();
    }

    handleTenantChange = e => this.props.authStore.setTenant(e.target.value);
    handleTenantOnBlur = e => this.props.authStore.validateTenant();

    handleSubmitForm = (e) => {
        e.preventDefault();
        if (!this.props.authStore.validateTenantForm()) return;

        this.props.adminConfigurationStore.getForgotPasswordSetting();
        this.props.authenticationProvidersStore.getAllAuthenticationProvidersOfTenant()
            .then((response) => {
                this.props.authStore.setLoginStep(this.props.authStore.loginSteps.passwordForm);
            });
    };

    render() {
 
        const { values, tenantValidationMessage, loginErrorMessage, inProgress } = this.props.authStore;
        const tenantField = <PortalTextBox 
                                id='txtTenant'
                                dataCy='tenant'
                                hintText={this.props.translationsStore.translate('ACCOUNT')}
                                floatingLabelText={this.props.translationsStore.translate('ACCOUNT')}
                                disabled={inProgress}
                                onChange={this.handleTenantChange}
                                autoComplete='on'
                                onBlur={this.handleTenantOnBlur}
                                errorText={tenantValidationMessage}
                                width='325px'
                                value={values.tenant}
                                ref='tenant'
                            />;

        const nextButton = <LargeButton
                                type='submit'
                                id='btnLoginSubmit'
                                dataCy='login-button'
                                inProgress={inProgress}
                                text='Next'
                                style={{marginTop: '25px', width: '325px'}}
                            />

        return (<div className="account-form">
                    <ValidationTopErrorMessage 
                        errorMessage={loginErrorMessage} 
                        dataCy='tenant-form-error'
                    />
                    <form onSubmit={this.handleSubmitForm}>
                        {tenantField}
                        {nextButton}
                    </form>
                </div>);
    
    }
}